// A list of reports that are in the v2 reports.
// We can use this as we redesign/refactor the reports.
const V2_REPORTS = ['applicationOverlap'];

// We need to be lowercase. We have them as camelCase in the backend,
// but the getReportType function in ChooseReportComponent.tsx
// returns the tab name, which is CapitalizedCamelCase.
const v2Reports = V2_REPORTS.map((report) => report.toLowerCase());

// Also need to convert the incoming reportType to lowercase.
const checkIfV2Report = (reportType?: string) =>
    v2Reports.includes(reportType?.toLowerCase() ?? '');

export const isV2Report = (reportType?: string) => checkIfV2Report(reportType);
